import { fetchQuery_DEPRECATED as fetchQuery } from 'react-relay/legacy';
import { getBuyerId } from 'dibs-cookie-jar';
import { type Environment } from 'react-relay/legacy';

import { DESKTOP } from '../../../../exports/deviceTypeEnums';
import { launchTradeGeneralOnboarding } from './launchTradeGeneralOnboarding';
import { tradeGeneralOnboardingQuery } from './tradeGeneralOnboardingQuery';
import { hasSeenTradeGeneralOnboarding, isUserTypeTrade } from './helpers';

import {
    type tradeGeneralOnboardingQuery$data,
    type tradeGeneralOnboardingQuery as QueryType,
} from './__generated__/tradeGeneralOnboardingQuery.graphql';

export const tradeGeneralOnboardingRule = async ({
    relayEnvironment,
}: {
    relayEnvironment: Environment;
}): Promise<boolean> => {
    const userId = getBuyerId(document.cookie);

    if (!userId || !isUserTypeTrade() || hasSeenTradeGeneralOnboarding()) {
        return Promise.resolve(false);
    }

    const response: tradeGeneralOnboardingQuery$data = await fetchQuery<QueryType>(
        relayEnvironment,
        tradeGeneralOnboardingQuery,
        { userId }
    );

    const isNewTradeUser =
        response.viewer?.user?.verifiedTradeSubStatus === 'VERIFIED_IN_LAST_30_DAYS';
    return isNewTradeUser;
};

export const tradeGeneralOnboardingConfig = {
    name: 'tradeGlobalOnboarding',
    rule: tradeGeneralOnboardingRule,
    deviceTypes: [DESKTOP],
    action: launchTradeGeneralOnboarding,
    priority: 450,
};
